import { render, staticRenderFns } from "./PicChooseTranslate.vue?vue&type=template&id=0f0cb7b4&scoped=true&"
import script from "./PicChooseTranslate.vue?vue&type=script&lang=js&"
export * from "./PicChooseTranslate.vue?vue&type=script&lang=js&"
import style0 from "./PicChooseTranslate.vue?vue&type=style&index=0&id=0f0cb7b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0cb7b4",
  null
  
)

export default component.exports